<template>
    <div>
        <div class="sousuo" style="width: 100%">
            <div style="width: 450px" class="yl-flex flex_between">
                <Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
            </div>
        </div>
        <div class="multiple">
            <div class="child-div">时间区间</div>
            <RadioGroup v-model="timePeriod">
                <Radio label="0"><span>不限</span></Radio>
                <Radio label="1"><span>今日</span></Radio>
                <Radio label="2"><span>昨日</span></Radio>
                <Radio label="3"><span>本周</span></Radio>
                <Radio label="4"><span>上周</span></Radio>
                <Radio label="5"><span>本月</span></Radio>
                <Radio label="6"><span>上月</span></Radio>
                <Radio label="7"><span>自定义</span></Radio>
                <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                            placeholder="选择日期" style="width: 200px"></DatePicker>
            </RadioGroup>
        </div>
        <div style="width: 100% ;margin-top: 20px;">
            <Table stripe border :columns="columns" :data="datas"  ref="table">
            </Table>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
	import { getAllMediumCode, getAccountStatic,getConsumptionList} from "../../api/runSet";

	export default {
        name: "AccountStatic",
		props:['clickTabValue'],
        data() {
            return {
                modal: false,
                name: '',
                timePeriod: '2',
                timePeriodDate: [],
                datas: [],
                columns: [
					{
					    "title": "投放平台",
					    "key": "cid_name",
						"align": 'center',
					},
                    {
                        "title": "投放平台id",
                        "key": "cid",
						"align": 'center',
                    },
					{
					    "title": "客户",
					    "key": "channel_name",
						"align": 'center',
					},
					{
					    "title": "客户id",
					    "key": "channel_id",
						"align": 'center',
					},
                    {
                        "title": "城市",
                        "key": "city",
						"align": 'center',
                    },
					{
					    "title": "表单数量",
					    "key": "num",
						"align": 'center',
					},
					{
					    "title": "报价成本",
					    "key": "quotation_average_money",
						"align": 'center',
					},
					{
					    "title": "投放成本",
					    "key": "form_cost",
						"align": 'center',
					},
					{
					    "title": "收入",
					    "key": "quotation_money",
						"align": 'center',
					},
					{
					    "title": "消耗",
					    "key": "adv_cost",
						"align": 'center',
					},
					{
					    "title": "收益",
					    "key": "earn_money",
						"align": 'center',
					},
                ],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		}, 
		mounted: function () {
			this.loadData();
		},
        methods: {		
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				// let data = {}
				// data.token = this.token;
				// let res = await getAllMediumCode(that, data);
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getConsumptionList(that, data);
				that.datas = res.data.list;
			},
			search() {
				this.getList();
			}
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
